import { render, staticRenderFns } from "./platformRights.vue?vue&type=template&id=74dab8bb&scoped=true"
import script from "./platformRights.vue?vue&type=script&lang=js"
export * from "./platformRights.vue?vue&type=script&lang=js"
import style0 from "./platformRights.vue?vue&type=style&index=0&id=74dab8bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dab8bb",
  null
  
)

export default component.exports